import type { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useEntryModalPrivateContext } from "../EntryModalPrivateContext"
import { usePolyglot } from "src/contexts"
import { useAccountMedications } from "src/hooks"
import type {
  AccountMedication,
  EditableSubEntry,
} from "src/types"

interface Option {
  value: string;
  children: string;
  disabled?: boolean;
}

export function useNameSelectOptions(): Array<Option> {
  const polyglot = usePolyglot()
  const { result: accountMedications } = useAccountMedications()

  const { originalSubEntry } = useEntryModalPrivateContext()
  const originalMedication = (originalSubEntry as EditableSubEntry<ActivityType.Medication> | undefined)?.med?.medication

  // calculate the options for the select menu
  const selectOptions: Array<Option> = useMemo(
    () => {
      // the default option
      const defaultOption: Option = {
        value: "",
        children: polyglot.t("components.entry_modal.medication.name.placeholder"),
        disabled: true,
      }

      let activityHasMatch = false
      const optionsArray: Array<Option> = accountMedications.map((accountMedication: AccountMedication) => {
        // TODO all ids will be strings in the future
        if (accountMedication.id === `${originalMedication?.account_med_id}`) {
          activityHasMatch = true
        }

        return {
          value: accountMedication.id,
          // TODO we are not yet localizing medication names
          children: accountMedication.med.name ?? "",
        }
      })


      // if the medication activity is not included in the current account
      // medications then add it as a disabled option
      if (!activityHasMatch && originalMedication?.account_med_id) {
        optionsArray.push({
          value: `${originalMedication.account_med_id}`,
          children: originalMedication.name ?? "",
        })
      }

      return [
        defaultOption,
        ...optionsArray,
      ]
    },
    [
      originalMedication,
      accountMedications,
      polyglot,
    ],
  )

  return selectOptions
}
